module.exports = __webpack_public_path__ + "img/Electricite_de_savoie_80X30.13cb5700.png";